<template>
  <div class="with-bg stats app-container">
    <div class="page-title">
      <h2>{{ $t('general.usersAndSubscriptions') }}</h2>
    </div>
    <div class="filter-container">
      <el-row>
        <el-col :span="8">
          <router-link :to="{path:'/members', query:{type: 'Donor'}}">
            <vs-card class="success-card">
              <template #title>
                <h3>{{ $t('general.donors') }}</h3>
              </template>
              <template #text>
                <h2><count-to :start-val="0" :end-val="stats.donors" :duration="3000" class="card-panel-num" /></h2>
              </template>
            </vs-card>
          </router-link>
        </el-col>
        <el-col :span="8">
          <router-link :to="{path:'/members', query:{type: 'Recipient'}}">
            <vs-card class="warning-card">
              <template #title>
                <h3>{{ $t('general.recipients') }}</h3>
              </template>
              <template #text>
                <h2><count-to :start-val="0" :end-val="stats.recipients" :duration="3000" class="card-panel-num" /></h2>
              </template>
            </vs-card>
          </router-link>
        </el-col>
        <el-col :span="8">
          <router-link :to="{path:'/members', query:{type: 'paired_exchange'}}">
            <vs-card class="default-card">
              <template #title>
                <h3>{{ $t('general.paredExchange') }}</h3>
              </template>
              <template #text>
                <h2><count-to :start-val="0" :end-val="stats.paired_exchange" :duration="3000" class="card-panel-num" /></h2>
              </template>
            </vs-card>
          </router-link>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import Resource from '@/api/resource';
import RoleResource from '@/api/role';
import checkPermission from '@/utils/permission'; // Vérification Permission
import CountTo from 'vue-count-to';
import checkRole from '@/utils/role'; // Vérification Roles
const subscriptionResource = new Resource('subscriptions');
const roleResource = new RoleResource();
export default {
  name: 'DashBoard',
  components: { CountTo },
  data() {
    return {
      adminsCount: 0,
      guestCount: 0,
      editorsCount: 0,
      list: null,
      total: 0,
      loading: true,
      query: {
        page: 1,
        limit: 15,
        keyword: '',
        role: '',
      },
      roles: [],
      stats: {
        donors: 0,
        paired_exchange: 0,
        recipients: 0,
      },
    };
  },

  created() {
    this.getRoles();
    this.getSubscriptionsStats('statistics');
  },
  methods: {
    checkPermission,
    checkRole,
    isEmptyArray(array){
      if (typeof array !== 'undefined' && array.length === 0) {
        return true;
      }
    },

    async getSubscriptionsStats(subUrl) {
      this.loading = true;
      const { data } = await subscriptionResource.sublist('/' + subUrl);
      this.stats = data;
      this.loading = false;
    },

    async getRoles() {
      this.loading = true;
      const { data } = await roleResource.list(this.query);
      this.roles = data;
      this.nonAdminRoles = [];
      this.roles.forEach(role => {
        if (role.name.toLowerCase() !== 'admin') {
          this.nonAdminRoles.push(role);
        }
      });
      this.loading = false;
      this.setSta();
    },

    getRoleUserCount(roleName){
      const found = this.roles.find(role => role.name === roleName);
      if (found) {
        return parseInt(found.userscount);
      } else {
        return 0;
      }
    },

    setSta(){
      this.adminsCount = this.getRoleUserCount('Admin');
      this.guestCount = this.getRoleUserCount('Guest');
      this.editorsCount = this.getRoleUserCount('Editor');
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-input {
  padding-right: 100px;
}
.cancel-btn {
  position: absolute;
  right: 15px;
  top: 10px;
}
.dialog-footer {
  text-align: left;
  padding-top: 0;
  margin-left: 150px;
}
.app-container {
  flex: 1;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  .block {
    float: left;
    min-width: 250px;
  }
  .clear-left {
    clear: left;
  }
}
</style>
